/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon16Regular = forwardRef('CertRosetteAltIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 .875a5.125 5.125 0 0 0-4 8.33v5.693a1.1 1.1 0 0 0 1.644.956L8 14.513l2.356 1.341A1.1 1.1 0 0 0 12 14.898V9.204a5.125 5.125 0 0 0-4-8.33ZM4.375 6a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0Zm6.125 4.475c-.74.414-1.592.65-2.5.65-.908 0-1.76-.236-2.5-.65v3.735l1.956-1.113a1.1 1.1 0 0 1 1.088 0L10.5 14.21v-3.735Z" })));
});
